var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "17px",
    viewBox: "0 0 9 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path_1076-path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.3179366,14.5584087 L4.3179366,1.26972016 C4.3179366,1.03729484 4.50153328,0.84887689 4.72801125,0.84887689 C4.95448923,0.84887689 5.1380859,1.03729484 5.1380859,1.26972016 L5.1380859,14.5584087 L7.70966089,11.9096661 C7.87179192,11.7600981 8.11961491,11.7668632 8.27376884,11.9250653 C8.42792276,12.0832673 8.43451478,12.3375982 8.28877394,12.5039868 L5.00191607,15.8771581 C4.84186622,16.0409473 4.58285288,16.0409473 4.42280302,15.8771581 L1.13594515,12.5039868 C1.02311662,12.399901 0.975503451,12.2403903 1.01216553,12.0893079 C1.04882761,11.9382255 1.16377375,11.8202609 1.31099019,11.782636 C1.45820663,11.7450112 1.61363577,11.7938747 1.71505821,11.9096661 L4.3179366,14.5584087 Z",
    id: "Path_1076-path",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.d3d7edfd430f9679f77cd0febdc99e99.svg";
export { ForwardRef as ReactComponent };